<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="form_title">
              <h1>{{ getTranslations.visitor_forgot_password_1_recover_your_password }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step">1</div>
              <div class="StandardRegSteps_step inactive">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng">
              <img class="form-help__icon" src="static/images/mobile-icon.svg" alt="">
              <h1>{{ getTranslations.visitor_forgot_password_1_forgot_your_pin }} </h1>
              <p>{{ getTranslations.visitor_forgot_password_1_please_enter }} </p>
            </div>
            <operator-selection v-if="hasResub()"
                                @choose="onOperatorChoose"
                                :error="operatorError">
            </operator-selection>
            <form action="">
              <div :class="[ ' form-group form-group--mobile form-group--icon', !hasErrors ? '' : 'has-warning' ]">
                <input type="number"
                       :placeholder="getTranslations.visitor_forgot_password_1_enter_mobile_number"
                       class="mobile form-group__textfield phone_input"
                       @keyup="check"
                       v-model="user.msisdn">
                <span class="form-group__feedback"
                      v-show="getMessage(message) && user.msisdn">
                  {{ getMessage(message) }}
                </span>
                <div v-if="checkBoxEnabled">
                  <div class="form-group for_selected_op form-group--checkbox center mt-sm-3 mb-sm-3 extra_line_height">
                    <input id="check" type="checkbox" value="terms_checked" v-model="termsParameter">
                    <label v-if="getTranslations.visitor_forgot_password_1_check_box_terms" for="check">{{ getTranslations.visitor_forgot_password_1_check_box_terms }}</label>
                    <label v-else-if="!getTranslations.visitor_forgot_password_1_check_box_terms" for="check">{{ getTranslations.visitor_forgot_password_1_check_first_text  }} <a>
                      <a :href="getTranslations.visitor_forgot_password_1_check_first_link_url" target="_blank">{{ getTranslations.visitor_forgot_password_1_check_first_link_text }}</a>
                    </a>{{ getTranslations.visitor_forgot_password_1_check_second_text }} <br><a>
                      <a :href="getTranslations.visitor_forgot_password_1_check_second_link_url" target="_blank">{{ getTranslations.visitor_forgot_password_1_check_second_link_text }}</a>
                    </a>{{ getTranslations.visitor_forgot_password_1_check_third_text }} <br><a>
                      <a :href="getTranslations.visitor_forgot_password_1_check_third_link_url" target="_blank">{{ getTranslations.visitor_forgot_password_1_check_third_link_text }}</a>
                    </a>
                      <br>
                      {{ getTranslations.visitor_forgot_password_1_check_fourth_text }}
                    </label>
                  </div>
                </div>
              </div>
              <button type="submit"
                      :class="['btn btn--medium btn--main', ( hasErrors || !termsParameter ? 'deactivated' : ''), (hasValidMsisdn ? '' : 'deactivated')]"
                      @click.prevent="checkButton">
                {{ getTranslations.visitor_forgot_password_1_submit_button_continue }}
              </button>

              <!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
              <!--span class="form-group__code">$#You need a new unique code? <a href="#">$#Resend me a code</a></span-->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';
import OperatorSelection from './OperatorSelection';

export default {
  name: 'forgotPassword1',
  mixins: [RegistrationFlowMixin, IntegrationMixin],
  components: {
    OperatorSelection,
  },
  data() {
    return {
      user: {
        msisdn: '',
        operator: '',
      },
      message: '',
      hasErrors: false,
      operatorError: false,
      hasStepsToDisplay: false,
      hasValidMsisdn: false,
      termsParameter: false,
    };
  },
  created() {
    if (!this.checkBoxEnabled) this.termsParameter = true;
    this.hasStepsToDisplay = this.hasSimplify();
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo',
    ]),
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.user.operator = operator;
    },
    onOperatorChoose(operator) {
      this.hasErrors = false;
      this.message = '';
      this.user.operator = operator;
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    clearData() {
      this.user.msisdn = '';
      this.message = '';
      this.hasErrors = false;
    },
    check() {
      const validMsisdnRegex = /^[0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
        this.hasValidMsisdn = true;
      }
    },
    checkButton() {
      this.operatorError = !this.user.operator;
      if (this.multiOperatorInfo.multiOperatorEnabled && this.user.operator === '') {
        this.noOperatorSelected = true;
        this.hasErrors = true;
        this.operatorError = true;
      }
      if (!this.hasErrors || !this.operatorError) {
        this.message = '';
        if (this.hasResub()) {
          this.alternateForgotProcess()();
        } else {
          this.standardForgotProcess();
        }
      } else {
        this.message = 'visitor_forgot_password_invalid_msisdn_msg';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'checkBoxEnabled',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue